module.exports = __webpack_public_path__ + "img/4.b140f6f5.jpg";